/* MTT Custom-Thermosflasche (Entwurf 23.10.2026), gehört zu sections/mtt-custom-flasche.liquid.
   Drei Wege: Wunschtext nach Vorlage (Hochkant, Name + Linie, Schild), eigenes Bild, Motiv aus der Reihe + Name.
   Ein einziger Zeichner malt das Design im Druckraster (100 × 205 mm, Unterkante = Flaschenboden):
   - in die 3D-Vorschau (Kern unten, unverändert aus assets/mtt-flasche-3d.js zwischen KERN-START und KERN-ENDE),
   - in die flache 2D-Ansicht (auch Rückfall ohne WebGL),
   - beim Kauf in die Druckdatei: PNG, 600 dpi (2362 × 4843 px), transparent, pHYs = 600 dpi.
   Upload in den Supabase-Bucket mtt-custom-uploads (Anon-Key, Pfadmuster uploads/<13 Ziffern>_<8 hex>.<endung> wie die RLS-Regel verlangt),
   Link als Positions-Eigenschaft _druckdatei. Der Bucket ist privat: Abruf nur mit Service-Key (werkzeug/druckdatei-holen.py). */
(function () {
  if (customElements.get('mtt-custom-flasche')) return;

/* 01.11.2026: Kern ersetzt durch Geometrie v3c (abgenommen 26.10.2026, MTT\3d\modelle\MTT-THER-01\MASSBLATT.md), Textgröße-Regler, Gestalter unter der Galerie */
/*KERN-START*/
  // ---- 3D-Kern: Flasche, Licht, Druck mit Relief, Bedienung. Braucht nur THREE (r128). ----
  var MTT3D = (function () {
    // Maße v3b (MASSBLATT.md, Messschieber John 26.10.2026, Johns Sichtkorrektur 26.10.2026 je −10 %): Höhe 226,5 mit Display,
    // Display 2,7 mm erhaben (Ø 57 → 49), Deckel 28 mm inkl. Kunststoffrand 2,25 mm, Bodenring 4,05 mm (2,43 gerade + Schräge).
    var MM = 0.001, D = 64.8, R = D / 2 * MM, H = 226.5 * MM, HDISP = 2.7 * MM, HD = 28 * MM, RAND = 2.25 * MM, HB = 4.05 * MM;
    var HB_GERADE = 2.43 * MM, B_SCHRAEG = 1.5 * MM, D_UNTEN = 57, D_OBEN = 49, D_GLAS = 46, D_ANZEIGE = 50;
    var DECKEL_OBEN = H - HDISP;              // Oberkante Deckellack (223,8 mm)
    var KOERPER = DECKEL_OBEN - HD;           // Oberkante Körper über Boden (195,8 mm)
    var UMFANG = Math.PI * D;                 // Abwicklung in mm
    var DRUCK_H = (KOERPER - HB) / MM;        // Höhe der Abwicklung in mm (Bodenring bis Kunststoffrand)
    var TINTE_MM = 0.45, RAU_LACK = 0.55, RAU_TINTE = 0.30, RAU_KUNSTSTOFF = 0.45;
    var LACK = { schwarz: '#0d0d0e', weiss: '#dcdcd8' };
    var SEG = 128;

    // Drehkörper mit vorgegebenen Normalen: punkte = [[r, y, nr, ny], ...] von unten nach oben (in Metern).
    // Gleiche Lage zweimal mit verschiedenen Normalen ergibt eine scharfe Kante ohne Schattierungsband.
    function drehkoerper(THREE, punkte, y0, y1) {
      var n = punkte.length, pos = [], nor = [], uv = [], idx = [];
      for (var i = 0; i <= SEG; i++) {
        var u = i / SEG, phi = Math.PI + u * Math.PI * 2, s = Math.sin(phi), c = Math.cos(phi);
        for (var j = 0; j < n; j++) {
          var p = punkte[j];
          pos.push(p[0] * s, p[1], p[0] * c);
          nor.push(p[2] * s, p[3], p[2] * c);
          uv.push(u, y1 > y0 ? Math.min(1, Math.max(0, (p[1] - y0) / (y1 - y0))) : 0);
        }
      }
      for (var a = 0; a < SEG; a++) {
        for (var b = 0; b < n - 1; b++) {
          var k = b + a * n;
          idx.push(k, k + n, k + 1, k + n, k + n + 1, k + 1);
        }
      }
      var g = new THREE.BufferGeometry();
      g.setIndex(idx);
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      g.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
      g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
      return g;
    }
    // Viertelkreis-Rundung um (cr, cy) mit Radius rad von Winkel a0 bis a1 (Bogenmaß).
    function bogen(pkt, cr, cy, rad, a0, a1, schritte) {
      for (var i = 0; i <= schritte; i++) {
        var a = a0 + (a1 - a0) * i / schritte, c = Math.cos(a), s = Math.sin(a);
        pkt.push([cr + rad * c, cy + rad * s, c, s]);
      }
      return pkt;
    }

    function Flasche(THREE, cv, opt) {
      opt = opt || {};
      var self = this;
      this.THREE = THREE; this.cv = cv; this.opt = opt;
      var renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true, powerPreference: 'high-performance' });
      renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1;
      renderer.setClearColor(0x000000, 0);
      this.renderer = renderer;
      var szene = this.szene = new THREE.Scene();
      this.kam = new THREE.PerspectiveCamera(28, 1, 0.01, 10);

      // Licht: weiche Studio-Umgebung für die Spiegelungen, dazu ein Führungslicht von links oben,
      // das die 0,45 mm hohe Druckkante sichtbar macht.
      if (THREE.RoomEnvironment && THREE.PMREMGenerator) {
        var pm = new THREE.PMREMGenerator(renderer);
        szene.environment = pm.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
        pm.dispose();
        szene.add(new THREE.HemisphereLight(0xffffff, 0x9a9a9a, 0.25));
      } else {
        szene.add(new THREE.HemisphereLight(0xffffff, 0xb8b8b8, 0.9));
        var l2 = new THREE.DirectionalLight(0xffffff, 0.7); l2.position.set(0.7, 0.4, 0.8); szene.add(l2);
        var l3 = new THREE.DirectionalLight(0xffffff, 0.6); l3.position.set(0, 0.3, -1); szene.add(l3);
      }
      var fuehrung = new THREE.DirectionalLight(0xffffff, 0.9); fuehrung.position.set(-0.6, 0.8, 0.9); szene.add(fuehrung);
      this.fuehrung = fuehrung;

      // Druck: Farbe, Normalen (Relief) und Rauheit als Abwicklung des Körpers. Zweierpotenz für Mipmaps.
      var G = renderer.capabilities.maxTextureSize >= 4096 ? 2048 : 1024;
      var aniso = Math.min(16, renderer.capabilities.getMaxAnisotropy());
      function leinwand(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
      this.cFarbe = leinwand(G, G); this.cNorm = leinwand(G, G); this.cRau = leinwand(G / 2, G / 2); this.cTinte = leinwand(G, G);
      function textur(c, srgb) {
        var t = new THREE.CanvasTexture(c);
        if (srgb) t.encoding = THREE.sRGBEncoding;
        t.anisotropy = aniso;
        t.minFilter = THREE.LinearMipmapLinearFilter; t.magFilter = THREE.LinearFilter; t.generateMipmaps = true;
        return t;
      }
      this.tFarbe = textur(this.cFarbe, true); this.tNorm = textur(this.cNorm, false); this.tRau = textur(this.cRau, false);

      // Materialien. Körper und Deckel: dieselbe Soft-Touch-Lackfläche (Farbe und Rauheit 0,55 identisch).
      this.matK = new THREE.MeshStandardMaterial({ map: this.tFarbe, normalMap: this.tNorm, roughnessMap: this.tRau, roughness: 1, metalness: 0 });
      this.matD = new THREE.MeshStandardMaterial({ color: 0x0d0d0e, roughness: RAU_LACK, metalness: 0 });
      var matP = new THREE.MeshStandardMaterial({ color: new THREE.Color(0x0b0b0c).convertSRGBToLinear(), roughness: RAU_KUNSTSTOFF, metalness: 0 });

      // Bodenring (schwarzer Kunststoff, 0,15 mm eingezogen): 2,43 mm gerade, darunter Schräge 1,5 mm radial bis zur Standfläche
      var rr = R - 0.15 * MM, zs = HB - HB_GERADE, sl = Math.hypot(zs, B_SCHRAEG), snr = zs / sl, sny = -B_SCHRAEG / sl;
      var pr = [[0, 0, 0, -1], [rr - B_SCHRAEG - 0.3 * MM, 0, 0, -1], [rr - B_SCHRAEG - 0.3 * MM, 0, snr, sny],
        [rr - B_SCHRAEG, 0.15 * MM, snr, sny], [rr - 0.1 * MM, zs - 0.1 * MM, snr, sny], [rr, zs + 0.15 * MM, 1, 0], [rr, HB + 0.2 * MM, 1, 0]];
      // Körper: unten 1,0 mm, oben 0,7 mm gerundet, Druck über die volle Höhe zwischen Bodenring und Kunststoffrand
      var pk = [[R - 1.5 * MM, HB, 0, -1]];
      bogen(pk, R - 1.0 * MM, HB + 1.0 * MM, 1.0 * MM, -Math.PI / 2, 0, 8);
      bogen(pk, R - 0.7 * MM, KOERPER - 0.7 * MM, 0.7 * MM, 0, Math.PI / 2, 8);
      pk.push([R - 2 * MM, KOERPER, 0, 1]);
      // Kunststoffrand unten am Deckel: 2,25 mm sichtbar, 0,2 mm eingerückt, Kanten gebrochen
      var rf = R - 0.2 * MM, pf = [[rf - 1.5 * MM, KOERPER, 0, -1], [rf - 0.35 * MM, KOERPER, 0.7071, -0.7071],
        [rf, KOERPER + 0.35 * MM, 1, 0], [rf, KOERPER + RAND - 0.3 * MM, 1, 0], [rf - 0.3 * MM, KOERPER + RAND, 0.7071, 0.7071],
        [rf - 1.5 * MM, KOERPER + RAND, 0, 1]];
      // Deckel: unten 0,7 mm, oben 2,4 mm gerundet, gleiche Lackfläche; oben bis zum Fuß des Displays
      var y0 = KOERPER + RAND, ru = D_UNTEN / 2 * MM, ro = D_OBEN / 2 * MM, rg = D_GLAS / 2 * MM, pd = [[R - 2 * MM, y0, 0, -1]];
      bogen(pd, R - 0.7 * MM, y0 + 0.7 * MM, 0.7 * MM, -Math.PI / 2, 0, 8);
      bogen(pd, R - 2.4 * MM, DECKEL_OBEN - 2.4 * MM, 2.4 * MM, 0, Math.PI / 2, 16);
      pd.push([ru - 0.5 * MM, DECKEL_OBEN, 0, 1]);
      // Display: erhabener Kegelstumpf, 2,7 mm hoch, unten Ø 57, oben Ø 49; Schräge dunkles Glas, weicher Glanz (v3c), 1,5 mm Rahmen ums Glas
      var kl = Math.hypot(ru - ro, HDISP), knr = HDISP / kl, kny = (ru - ro) / kl;
      var pz = [[ru, DECKEL_OBEN - 0.2 * MM, 1, 0], [ru, DECKEL_OBEN, knr, kny], [ro + 0.3 * MM, H - 0.3 * MM, knr, kny],
        [ro, H, 0, 1], [rg + 0.2 * MM, H, 0, 1], [rg, H - 0.3 * MM, -1, 0], [rg - 0.5 * MM, H - 0.3 * MM, 0, 1]];

      var koerper = new THREE.Mesh(drehkoerper(THREE, pk, HB, KOERPER), this.matK);
      var deckel = new THREE.Mesh(drehkoerper(THREE, pd, 0, 0), this.matD);
      var ring = new THREE.Mesh(drehkoerper(THREE, pr, 0, 0), matP);
      var fuge = new THREE.Mesh(drehkoerper(THREE, pf, 0, 0), matP);
      var rahmen = new THREE.Mesh(drehkoerper(THREE, pz.slice(3), 0, 0), matP);
      var matSchraege = new THREE.MeshStandardMaterial({ color: 0x050505, roughness: 0.22, metalness: 0, envMapIntensity: 0.6 });   // v3c: weicher, keine Spiegelflecken
      var schraege = new THREE.Mesh(drehkoerper(THREE, pz.slice(0, 4), 0, 0), matSchraege);
      // Deckglas Ø 46 mm, 0,3 mm vertieft; die Anzeige-Grafik deckt wie im Blender-Modell 50 mm ab (Rand vom Rahmen verdeckt)
      this.matGlas = new THREE.MeshStandardMaterial({ color: 0x050505, roughness: 0.08, metalness: 0, emissive: 0xffffff, emissiveIntensity: 0.9 });
      var gg = new THREE.CircleGeometry(rg, SEG), guv = gg.attributes.uv, gk = D_GLAS / D_ANZEIGE;
      for (var gi = 0; gi < guv.count; gi++) guv.setXY(gi, 0.5 + (guv.getX(gi) - 0.5) * gk, 0.5 + (guv.getY(gi) - 0.5) * gk);
      var glas = new THREE.Mesh(gg, this.matGlas);
      glas.rotation.x = -Math.PI / 2; glas.position.y = H - 0.3 * MM + 0.01 * MM;
      if (opt.display) {
        var ld = new THREE.TextureLoader(); ld.setCrossOrigin('anonymous');
        ld.load(opt.display, function (t) { t.encoding = THREE.sRGBEncoding; t.anisotropy = aniso; self.matGlas.emissiveMap = t; self.matGlas.needsUpdate = true; self.malen(); });
      } else { this.matGlas.emissiveIntensity = 0; }

      // Weicher Schatten: Ebene mit radialem Verlauf, dunkler Kern direkt unter dem Bodenring
      var cs = leinwand(256, 256), sx = cs.getContext('2d'), gr = sx.createRadialGradient(128, 128, 0, 128, 128, 128);
      gr.addColorStop(0, 'rgba(0,0,0,0.55)'); gr.addColorStop(0.26, 'rgba(0,0,0,0.42)'); gr.addColorStop(0.32, 'rgba(0,0,0,0.2)');
      gr.addColorStop(0.55, 'rgba(0,0,0,0.07)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      sx.fillStyle = gr; sx.fillRect(0, 0, 256, 256);
      var schatten = new THREE.Mesh(new THREE.PlaneGeometry(0.25, 0.25),
        new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(cs), transparent: true, depthWrite: false, toneMapped: false }));
      schatten.rotation.x = -Math.PI / 2; schatten.position.y = -0.05 * MM; schatten.renderOrder = -1;

      var flasche = new THREE.Group(); flasche.add(ring, koerper, fuge, deckel, schraege, rahmen, glas);
      szene.add(schatten, flasche);

      this.farbe = 'schwarz'; this.zeichner = null;
      // Kamera: Kreisbahn um die Flasche; nah = Doppeltippen/Doppelklick auf die Druckmitte
      this.dreh = 0; this.neig = 0.18; this.abst = 0.62; this.zielY = H * 0.5; this.nah = false;
      this.bedienung();
      this.groesse();
    }

    Flasche.prototype.malen = function () {
      if (this._geplant) return;
      var self = this; this._geplant = true;
      requestAnimationFrame(function () { self._geplant = false; self.renderer.render(self.szene, self.kam); });
    };
    Flasche.prototype.groesse = function () {
      var w = this.cv.clientWidth, h = this.cv.clientHeight || w;
      if (!w) return;
      this.renderer.setSize(w, h, false);
      this.kam.aspect = w / h; this.kam.updateProjectionMatrix();
      this.kamera();
    };
    Flasche.prototype.kamera = function () {
      var k = this.kam, d = this.dreh, n = this.neig, a = this.abst;
      k.position.set(Math.sin(d) * Math.cos(n) * a, this.zielY + Math.sin(n) * a, Math.cos(d) * Math.cos(n) * a);
      k.lookAt(0, this.zielY, 0);
      // Führungslicht wandert mit der Kamera, damit die Reliefkante von jeder Seite Licht fängt
      this.fuehrung.position.set(Math.sin(d - 0.7) * 0.9, 0.8, Math.cos(d - 0.7) * 0.9);
      this.malen();
    };
    // Weich zwischen Gesamtansicht und Nahansicht wechseln
    Flasche.prototype.zoom = function (nah) {
      var self = this, a0 = this.abst, y0 = this.zielY, a1 = nah ? 0.28 : 0.62, y1 = nah ? 0.11 : H * 0.5, t0 = performance.now();
      this.nah = nah;
      cancelAnimationFrame(this._zoomLauf);
      (function schritt(t) {
        var p = Math.min(1, (t - t0) / 420), e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        self.abst = a0 + (a1 - a0) * e; self.zielY = y0 + (y1 - y0) * e; self.kamera();
        if (p < 1) self._zoomLauf = requestAnimationFrame(schritt);
      })(t0);
    };
    Flasche.prototype.bedienung = function () {
      var self = this, cv = this.cv, opt = this.opt, zieh = null, letzt = null;
      cv.addEventListener('pointerdown', function (e) {
        zieh = { x: e.clientX, y: e.clientY, x0: e.clientX, y0: e.clientY, neigen: e.pointerType === 'mouse' || opt.touchNeigen };
        try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      });
      cv.addEventListener('pointermove', function (e) {
        if (!zieh) return;
        self.dreh -= (e.clientX - zieh.x) * 0.01;
        if (zieh.neigen) self.neig = Math.max(-0.3, Math.min(1.2, self.neig + (e.clientY - zieh.y) * 0.005));
        zieh.x = e.clientX; zieh.y = e.clientY;
        self.kamera();
      });
      cv.addEventListener('pointerup', function (e) {
        if (!zieh) return;
        var tipp = Math.abs(e.clientX - zieh.x0) + Math.abs(e.clientY - zieh.y0) < 12, jetzt = performance.now();
        zieh = null;
        if (!tipp) { letzt = null; return; }
        if (letzt && jetzt - letzt.t < 350 && Math.abs(e.clientX - letzt.x) + Math.abs(e.clientY - letzt.y) < 40) { letzt = null; self.zoom(!self.nah); }
        else letzt = { t: jetzt, x: e.clientX, y: e.clientY };
      });
      var los = function () { zieh = null; };
      cv.addEventListener('pointercancel', los);
      if (opt.mausrad) {
        cv.addEventListener('wheel', function (e) {
          e.preventDefault(); self.abst = Math.max(0.2, Math.min(1.0, self.abst * (1 + e.deltaY * 0.001))); self.kamera();
        }, { passive: false });
      }
    };

    // Druck neu aufbauen. zeichner(ctx) malt die Tinte in Millimetern: x 0 … Umfang (Mitte zeigt zur Kamera),
    // y 0 = Oberkante Körper am Kunststoffrand, nach unten bis zum Bodenring. null = blanke Flasche.
    Flasche.prototype.setze = function (farbe, zeichner) {
      var THREE = this.THREE, G = this.cFarbe.width;
      this.farbe = farbe; this.zeichner = zeichner;
      var lack = LACK[farbe] || LACK.schwarz;
      this.matD.color.set(lack).convertSRGBToLinear();
      this.renderer.toneMappingExposure = farbe === 'weiss' ? 0.9 : 1.0;

      var ct = this.cTinte.getContext('2d');
      ct.setTransform(1, 0, 0, 1, 0, 0); ct.clearRect(0, 0, G, G);
      if (zeichner) {
        ct.setTransform(G / UMFANG, 0, 0, G / DRUCK_H, 0, 0);
        ct.imageSmoothingEnabled = true; ct.imageSmoothingQuality = 'high';
        zeichner(ct);
        ct.setTransform(1, 0, 0, 1, 0, 0);
      }
      var cf = this.cFarbe.getContext('2d');
      cf.fillStyle = lack; cf.fillRect(0, 0, G, G); cf.drawImage(this.cTinte, 0, 0);

      var cn = this.cNorm.getContext('2d'), cr = this.cRau.getContext('2d'), rl = Math.round(RAU_LACK * 255);
      cn.fillStyle = 'rgb(128,128,255)'; cn.fillRect(0, 0, G, G);
      cr.fillStyle = 'rgb(' + rl + ',' + rl + ',' + rl + ')'; cr.fillRect(0, 0, G / 2, G / 2);
      if (zeichner) this.relief(ct, cn, cr, G);
      this.tFarbe.needsUpdate = true; this.tNorm.needsUpdate = true; this.tRau.needsUpdate = true;
      this.malen();
    };

    // Relief aus dem Alpha: Höhe = Deckung × 0,45 mm, leicht weichgezeichnet (echte Druckkante ist minimal rund),
    // Neigung per Sobel, daraus Tangentenraum-Normalen. Rauheit: Tinte 0,30, Lack 0,55.
    Flasche.prototype.relief = function (ct, cn, cr, G) {
      var a = ct.getImageData(0, 0, G, G).data, x0 = G, y0 = G, x1 = -1, y1 = -1, x, y, i;
      for (y = 0; y < G; y++) for (x = 0; x < G; x++) if (a[(y * G + x) * 4 + 3] > 2) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      if (x1 < 0) return;
      var RD = 4; x0 = Math.max(0, x0 - RD); y0 = Math.max(0, y0 - RD); x1 = Math.min(G - 1, x1 + RD); y1 = Math.min(G - 1, y1 + RD);
      var w = x1 - x0 + 1, h = y1 - y0 + 1, hf = new Float32Array(w * h), tmp = new Float32Array(w * h);
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) hf[y * w + x] = a[((y + y0) * G + x + x0) * 4 + 3] / 255;
      // zweimal 3er-Kastenfilter je Richtung ≈ Gauß mit σ ≈ 1 px (≈ 0,1 mm)
      for (var r = 0; r < 2; r++) {
        for (y = 0; y < h; y++) for (x = 0; x < w; x++) { i = y * w + x; tmp[i] = (hf[x > 0 ? i - 1 : i] + hf[i] + hf[x < w - 1 ? i + 1 : i]) / 3; }
        for (y = 0; y < h; y++) for (x = 0; x < w; x++) { i = y * w + x; hf[i] = (tmp[y > 0 ? i - w : i] + tmp[i] + tmp[y < h - 1 ? i + w : i]) / 3; }
      }
      var kx = TINTE_MM * G / UMFANG / 8, ky = TINTE_MM * G / DRUCK_H / 8;   // Höheneinheit → mm Steigung je mm
      var nb = cn.createImageData(w, h), nd = nb.data, rb = new ImageData(w, h), rd = rb.data;
      for (y = 0; y < h; y++) {
        var yo = y > 0 ? -w : 0, yu = y < h - 1 ? w : 0;
        for (x = 0; x < w; x++) {
          i = y * w + x;
          var xl = x > 0 ? -1 : 0, xr = x < w - 1 ? 1 : 0;
          var gx = (hf[i + yo + xr] + 2 * hf[i + xr] + hf[i + yu + xr]) - (hf[i + yo + xl] + 2 * hf[i + xl] + hf[i + yu + xl]);
          var gy = (hf[i + yu + xl] + 2 * hf[i + yu] + hf[i + yu + xr]) - (hf[i + yo + xl] + 2 * hf[i + yo] + hf[i + yo + xr]);
          var nx = -gx * kx, ny = gy * ky, l = 1 / Math.sqrt(nx * nx + ny * ny + 1), o = i * 4;
          nd[o] = (nx * l * 0.5 + 0.5) * 255; nd[o + 1] = (ny * l * 0.5 + 0.5) * 255; nd[o + 2] = (l * 0.5 + 0.5) * 255; nd[o + 3] = 255;
          var al = a[((y + y0) * G + x + x0) * 4 + 3] / 255, ro = (RAU_LACK + (RAU_TINTE - RAU_LACK) * al) * 255;
          rd[o] = ro; rd[o + 1] = ro; rd[o + 2] = ro; rd[o + 3] = 255;
        }
      }
      cn.putImageData(nb, x0, y0);
      var hilf = document.createElement('canvas'); hilf.width = w; hilf.height = h; hilf.getContext('2d').putImageData(rb, 0, 0);
      cr.imageSmoothingEnabled = true; cr.drawImage(hilf, x0 / 2, y0 / 2, w / 2, h / 2);
    };

    return { Flasche: Flasche, UMFANG: UMFANG, DRUCK_H: DRUCK_H, KOERPER_MM: KOERPER / MM, H_MM: H / MM };
  })();
/*KERN-ENDE*/

  // ---------- Druckraster und Regeln ----------
  var RASTER_B = 100, RASTER_H = 205, OBEN_MM = 21.5;          // Druckdatei 100 × 205 mm, 21,5 mm unter der Deckeloberkante
  var DPI = 600, PX_MM = DPI / 25.4;                           // 23,622 px/mm
  var DRUCK_W = Math.round(RASTER_B * PX_MM), DRUCK_H = Math.round(RASTER_H * PX_MM); // 2362 × 4843
  var TINTE = { schwarz: '#FFFFFF', weiss: '#111113' };       // helle Tinte auf Schwarz, dunkle auf Weiß (wie die Motive)
  var ROT = '#F0221C', BLAU = '#1F4FBF', GELB = '#FFD200';
  var LACK = { schwarz: '#0d0d0e', weiss: '#dcdcd8' };
  var TG_MIN = 50;                                             // 01.11.2026 Johns Wunsch: Regler für die Textgröße, 50 bis 100 % der Vorlage
  var TEXT_MITTE = {"hoch": [50, 94], "name": [50, 95], "schild": [50, 95]};   // Mittelpunkt je Vorlage, um den verkleinert wird (mm)
  var MIN_KAPPE = 4.5;                                         // mm Versalhöhe: darunter werden Striche dünner als 0,75 mm
  var MAX_DATEI = 9.8 * 1024 * 1024;                           // Bucket-Grenze 10 MB
  var FONT = 'Montserrat';
  var VORLAGEN = {
    hoch:   { name: 'Hochkant',     max: 12 },
    name:   { name: 'Name + Linie', max: 14 },
    schild: { name: 'Schild',       max: 9 }
  };
  var BILD_FLAECHE = { x0: 0, x1: 100, y0: 10, y1: 179 };     // freie Fläche für eigene Bilder (über dem Logo)

  function gross(t) { return String(t || '').toLocaleUpperCase('de-DE'); }
  function sauber(t, max) {
    // Nur Zeichen, die Montserrat sicher hat und die sauber drucken
    return String(t || '').replace(/[^A-Za-z0-9ÄÖÜäöüß .,:!?&+\-'#\/]/g, '').replace(/\s+/g, ' ').slice(0, max);
  }

  // ---------- Schrift messen ----------
  var KAPPE = 0.7;
  function kappeMessen() {
    var c = document.createElement('canvas').getContext('2d');
    c.font = '900 100px ' + FONT;
    var m = c.measureText('H');
    if (m.actualBoundingBoxAscent) KAPPE = m.actualBoundingBoxAscent / 100;
  }
  // Breite mit Laufweite (track in em), da ctx.letterSpacing nicht überall geht
  function breite(ctx, t, groesse, track) {
    var b = 0;
    for (var i = 0; i < t.length; i++) b += ctx.measureText(t[i]).width;
    return b + Math.max(0, t.length - 1) * track * groesse;
  }
  function textMittig(ctx, t, cx, grundlinie, groesse, track) {
    var w = breite(ctx, t, groesse, track), x = cx - w / 2;
    ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
    for (var i = 0; i < t.length; i++) { ctx.fillText(t[i], x, grundlinie); x += ctx.measureText(t[i]).width + track * groesse; }
    return w;
  }
  // Größte Schrift, die in maxB × maxKappe passt
  function einpassen(ctx, t, gewicht, track, maxB, maxKappe) {
    ctx.font = gewicht + ' 10px ' + FONT;
    var b10 = breite(ctx, t, 10, track) || 1;
    var g = Math.min(maxKappe / KAPPE, maxB * 10 / b10);
    ctx.font = gewicht + ' ' + g.toFixed(3) + 'px ' + FONT;
    return { g: g, kappe: g * KAPPE, b: breite(ctx, t, g, track) };
  }
  function abgerundet(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y); ctx.arcTo(x + w, y, x + w, y + r, r);
    ctx.lineTo(x + w, y + h - r); ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
    ctx.lineTo(x + r, y + h); ctx.arcTo(x, y + h, x, y + h - r, r);
    ctx.lineTo(x, y + r); ctx.arcTo(x, y, x + r, y, r); ctx.closePath();
  }

  // ---------- Der eine Zeichner (Einheit: mm im Druckraster) ----------
  // q: { logo:{schwarz,weiss}, logoPos:{x,y}, motiv:Image|null, motivB:Zahl, bild:Canvas|Image|null }
  // Rückgabe: { ok, kappe } (kappe = kleinste Versalhöhe in mm, für die Strichstärken-Prüfung)
  function zeichneDesign(ctx, z, q) {
    var tinte = TINTE[z.farbe] || TINTE.schwarz, info = { ok: true, kappe: 99, leer: false };
    ctx.fillStyle = tinte; ctx.strokeStyle = tinte;
    var logo = function () {
      var l = q.logo && q.logo[z.farbe];
      if (l && l.naturalWidth) ctx.drawImage(l, q.logoPos.x, q.logoPos.y, l.naturalWidth / PX_MM, l.naturalHeight / PX_MM);
    };

    if (z.weg === 'text') {
      var t = gross(z.text).trim();
      if (!t) { info.leer = true; logo(); return info; }
      var m;
      var tg = Math.max(TG_MIN, Math.min(100, +z.tg || 100)) / 100, tm = TEXT_MITTE[z.vorlage] || [RASTER_B / 2, RASTER_H / 2];
      ctx.save();
      if (tg < 1) { ctx.translate(tm[0], tm[1]); ctx.scale(tg, tg); ctx.translate(-tm[0], -tm[1]); }
      if (z.vorlage === 'hoch') {
        // Großes Wort senkrecht, von unten nach oben lesbar wie „Ladepause“
        m = einpassen(ctx, t, 900, 0.02, 148, 26);
        ctx.save(); ctx.translate(50, 94); ctx.rotate(-Math.PI / 2);
        textMittig(ctx, t, 0, m.kappe / 2, m.g, 0.02);
        ctx.restore();
        ctx.fillStyle = ROT; ctx.fillRect(50 - 8, 94 + m.b / 2 + 6, 16, 1.6);
        info.kappe = m.kappe;
      } else if (z.vorlage === 'name') {
        // Name waagerecht, rote Linie darunter
        // max. 62 mm breit: so bleibt der Name von vorn ganz lesbar (Umfang 203,6 mm, 62 mm ≈ 110° Bogen)
        m = einpassen(ctx, t, 800, 0.08, 62, 13);
        textMittig(ctx, t, 50, 95 + m.kappe / 2, m.g, 0.08);
        var lb = Math.max(22, Math.min(62, m.b * 0.62));
        ctx.fillStyle = ROT; ctx.fillRect(50 - lb / 2, 95 + m.kappe / 2 + 4.2, lb, 1.6);
        info.kappe = m.kappe;
      } else {
        // Schild im Kennzeichen-Look: Rahmen, blaues Band mit Sternenkranz, kein Länderkürzel, kein Siegel
        // 64 × 15 mm (Seitenverhältnis wie ein echtes Schild), von vorn ganz sichtbar
        var x = 18, y = 87.5, w = 64, h = 15, r = 2, s = Math.max(1.1, 0.8 / tg), bb = 7.5;
        ctx.save(); abgerundet(ctx, x, y, w, h, r); ctx.clip();
        ctx.fillStyle = BLAU; ctx.fillRect(x, y, bb, h);
        ctx.restore();
        ctx.fillStyle = GELB;   // Sternenkranz: 12 Punkte Ø 0,9 mm (≥ 0,75 mm), kein Länderkürzel
        for (var i = 0; i < 12; i++) {
          var a = i / 12 * Math.PI * 2;
          ctx.beginPath(); ctx.arc(x + bb / 2 + 0.3 + Math.cos(a) * 2, y + 5.2 + Math.sin(a) * 2, Math.max(0.45, 0.4 / tg), 0, Math.PI * 2); ctx.fill();
        }
        ctx.strokeStyle = tinte; ctx.lineWidth = s;
        abgerundet(ctx, x + s / 2, y + s / 2, w - s, h - s, r - s / 2); ctx.stroke();
        ctx.fillStyle = tinte;
        m = einpassen(ctx, t, 800, 0.05, w - bb - 6, 8.5);
        textMittig(ctx, t, x + bb + (w - bb) / 2, y + h / 2 + m.kappe / 2, m.g, 0.05);
        info.kappe = m.kappe;
      }
      ctx.restore();
      info.kappe *= tg;   // echte Versalhöhe nach dem Verkleinern, für die 4,5-mm-Prüfung
      logo();
    } else if (z.weg === 'bild') {
      var b = q.bild;
      if (!b) { info.leer = true; logo(); return info; }
      var bw = b.naturalWidth || b.width, bh = b.naturalHeight || b.height;
      var F = BILD_FLAECHE, breiteMm = (F.x1 - F.x0) * z.groesse / 100, hoeheMm = breiteMm * bh / bw;
      var maxH = F.y1 - F.y0;
      if (hoeheMm > maxH) { hoeheMm = maxH; breiteMm = hoeheMm * bw / bh; }
      var cy = F.y0 + hoeheMm / 2 + (maxH - hoeheMm) * z.lage / 100;
      ctx.save(); ctx.beginPath(); ctx.rect(F.x0, F.y0, F.x1 - F.x0, F.y1 - F.y0); ctx.clip();
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(b, 50 - breiteMm / 2, cy - hoeheMm / 2, breiteMm, hoeheMm);
      ctx.restore();
      info.breiteMm = breiteMm; info.hoeheMm = hoeheMm; info.dpi = bw / (breiteMm / 25.4);
      logo();
    } else {
      // Motiv aus der Reihe: Motivdatei in Originalgröße (enthält schon das Logo) + Name im freien Feld
      var mo = q.motiv, d = z.motivDaten;
      if (mo && d) ctx.drawImage(mo, (RASTER_B - d.b) / 2, 0, d.b, RASTER_H);
      var n = gross(z.name).trim();
      if (!n) { info.leer = true; return info; }
      if (d) {
        m = einpassen(ctx, n, 800, 0.12, d.slot.w, d.slot.kappe);
        ctx.fillStyle = tinte;
        textMittig(ctx, n, 50, d.slot.y + m.kappe / 2, m.g, 0.12);
        info.kappe = m.kappe;
      }
    }
    if (info.kappe < MIN_KAPPE) info.ok = false;
    return info;
  }

  // ---------- PNG mit 600 dpi (pHYs-Block) ----------
  var CRC = null;
  function crc32(bytes) {
    if (!CRC) { CRC = new Uint32Array(256); for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; CRC[n] = c >>> 0; } }
    var c2 = 0xFFFFFFFF; for (var i = 0; i < bytes.length; i++) c2 = CRC[(c2 ^ bytes[i]) & 0xFF] ^ (c2 >>> 8);
    return (c2 ^ 0xFFFFFFFF) >>> 0;
  }
  function mitDpi(blob) {
    return blob.arrayBuffer().then(function (buf) {
      var a = new Uint8Array(buf);
      if (a[12] !== 0x49 || a[13] !== 0x48) return blob;      // kein IHDR an erwarteter Stelle: unverändert lassen
      var ppm = Math.round(DPI / 0.0254), d = new Uint8Array(21), v = new DataView(d.buffer);
      v.setUint32(0, 9); d.set([0x70, 0x48, 0x59, 0x73], 4);  // Länge 9, „pHYs“
      v.setUint32(8, ppm); v.setUint32(12, ppm); d[16] = 1;
      v.setUint32(17, crc32(d.subarray(4, 17)));
      return new Blob([a.subarray(0, 33), d, a.subarray(33)], { type: 'image/png' });
    });
  }
  function alsBlob(cv, typ, q) { return new Promise(function (ok) { cv.toBlob(ok, typ, q); }); }

  function hex8() {
    var a = new Uint8Array(4); (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
  }
  function bildLaden(src) {
    return new Promise(function (ok, fehler) {
      var i = new Image(); i.crossOrigin = 'anonymous';
      i.onload = function () { ok(i); }; i.onerror = fehler; i.src = src;
    });
  }
  function euro(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }

  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var ROOM_URL = 'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/environments/RoomEnvironment.js';
  function skript(url) {
    return new Promise(function (ok, fehler) {
      var s = document.createElement('script'); s.src = url; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = ok; s.onerror = fehler; document.head.appendChild(s);
    });
  }
  function ladeThree() {
    return (window.THREE ? Promise.resolve() : skript(THREE_URL))
      .then(function () { return window.THREE.RoomEnvironment ? null : skript(ROOM_URL).catch(function () {}); })
      .then(function () { return window.THREE; });
  }

  var SPEICHER = 'mtt_custom_flasche_v1';

  class MttCustomFlasche extends HTMLElement {
    connectedCallback() {
      if (this._an) return; this._an = true;
      try { this.daten = JSON.parse(this.querySelector('script[data-mcf-daten]').textContent); } catch (e) { return; }
      var self = this;
      this.$ = function (s) { return self.querySelector(s); };
      this.$$ = function (s) { return Array.prototype.slice.call(self.querySelectorAll(s)); };
      this.z = { farbe: 'schwarz', weg: 'text', vorlage: 'hoch', text: '', motiv: Object.keys(this.daten.motive)[0], name: '', tg: 100, groesse: 60, lage: 50, freistellen: false, rechte: false };
      this.laden();
      this.bild = { datei: null, quelle: null, frei: null, upload: null, laeuft: null, fehler: '' };
      this.q = { logo: {}, logoPos: this.daten.logo, motiv: null, bild: null };
      this.vorschauBilder = {};
      this.fontsBereit = this.schriftLaden();
      this.binden();
      this.uiAusZustand();
      Promise.all(['schwarz', 'weiss'].map(function (f) {
        return bildLaden(self.daten.logo[f]).then(function (i) { self.q.logo[f] = i; }).catch(function () {});
      })).then(function () { self.neuZeichnen(true); });
      this.fontsBereit.then(function () { self.neuZeichnen(true); });
      this.start3dSpaet();
      this.stickyKauf();
    }

    // ---------- Zustand merken (ohne Bild) ----------
    laden() {
      try {
        var s = JSON.parse(localStorage.getItem(SPEICHER) || 'null');
        if (!s) return;
        ['farbe', 'weg', 'vorlage', 'text', 'motiv', 'name'].forEach(function (k) { if (typeof s[k] === 'string') this.z[k] = s[k]; }, this);
        if (s && typeof s.tg === 'number') this.z.tg = s.tg;
      } catch (e) {}
      if (!LACK[this.z.farbe]) this.z.farbe = 'schwarz';
      if (['text', 'bild', 'motiv'].indexOf(this.z.weg) < 0) this.z.weg = 'text';
      if (!VORLAGEN[this.z.vorlage]) this.z.vorlage = 'hoch';
      if (!this.daten.motive[this.z.motiv]) this.z.motiv = Object.keys(this.daten.motive)[0];
      this.z.text = sauber(this.z.text, VORLAGEN[this.z.vorlage].max);
      this.z.name = sauber(this.z.name, 14);
      this.z.tg = Math.max(TG_MIN, Math.min(100, Math.round(+this.z.tg || 100)));
    }
    merken() {
      try { localStorage.setItem(SPEICHER, JSON.stringify({ farbe: this.z.farbe, weg: this.z.weg, vorlage: this.z.vorlage, text: this.z.text, motiv: this.z.motiv, name: this.z.name, tg: this.z.tg })); } catch (e) {}
    }

    schriftLaden() {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      return Promise.all([document.fonts.load('900 40px ' + FONT, 'ÄÖÜ'), document.fonts.load('800 40px ' + FONT, 'ÄÖÜ')])
        .then(function (r) { kappeMessen(); return r; })
        .catch(function () {});
    }

    // ---------- Bedienung ----------
    binden() {
      var self = this;
      this.$$('[data-mcf-farbe]').forEach(function (b) {
        b.addEventListener('click', function () { self.z.farbe = b.dataset.mcfFarbe; self.geaendert(true); });
      });
      this.$$('[data-mcf-weg]').forEach(function (b) {
        b.addEventListener('click', function () { self.z.weg = b.dataset.mcfWeg; self.geaendert(true); });
      });
      this.$$('[data-mcf-vorlage]').forEach(function (b) {
        b.addEventListener('click', function () {
          self.z.vorlage = b.dataset.mcfVorlage;
          self.z.text = sauber(self.z.text, VORLAGEN[self.z.vorlage].max);
          self.geaendert(true);
        });
      });
      this.$$('[data-mcf-motiv]').forEach(function (b) {
        b.addEventListener('click', function () { self.z.motiv = b.dataset.mcfMotiv; self.geaendert(true); });
      });
      var txt = this.$('[data-mcf-feld="text"]'), nm = this.$('[data-mcf-feld="name"]');
      var tgr = this.$('[data-mcf-feld="textgroesse"]');
      if (tgr) tgr.addEventListener('input', function () { self.z.tg = +tgr.value; self.geaendert(false); });
      txt.addEventListener('input', function () {
        var s = sauber(txt.value, VORLAGEN[self.z.vorlage].max);
        if (s !== txt.value) txt.value = s;
        self.z.text = s; self.geaendert(false);
      });
      nm.addEventListener('input', function () {
        var s = sauber(nm.value, 14);
        if (s !== nm.value) nm.value = s;
        self.z.name = s; self.geaendert(false);
      });
      var gr = this.$('[data-mcf-feld="groesse"]'), lg = this.$('[data-mcf-feld="lage"]');
      gr.addEventListener('input', function () { self.z.groesse = +gr.value; self.geaendert(false); });
      lg.addEventListener('input', function () { self.z.lage = +lg.value; self.geaendert(false); });
      var fr = this.$('[data-mcf-feld="freistellen"]');
      fr.addEventListener('change', function () { self.z.freistellen = fr.checked; self.freistellen(); });
      var re = this.$('[data-mcf-feld="rechte"]');
      re.addEventListener('change', function () { self.z.rechte = re.checked; self.fehler(''); if (re.checked) self.originalHochladen().catch(function () {}); self.uiAusZustand(); });
      var dt = this.$('[data-mcf-feld="datei"]');
      dt.addEventListener('change', function () { if (dt.files && dt.files[0]) self.dateiGewaehlt(dt.files[0]); });
      var zone = this.$('[data-mcf-zone]');
      ['dragover', 'dragenter'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('ist-drueber'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { zone.addEventListener(ev, function () { zone.classList.remove('ist-drueber'); }); });
      zone.addEventListener('drop', function (e) { e.preventDefault(); var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) self.dateiGewaehlt(f); });
      var weg = this.$('[data-mcf-bild-weg]');
      if (weg) weg.addEventListener('click', function () { self.bildEntfernen(); });
      this.$$('[data-mcf-kauf]').forEach(function (b) { b.addEventListener('click', function () { self.kaufen(b); }); });
      var flach = this.$('[data-mcf-flach-knopf]');
      if (flach) flach.addEventListener('click', function () { self.flachUmschalten(); });
    }

    geaendert(sofort) {
      this.fehler('');
      this.uiAusZustand();
      this.merken();
      this.neuZeichnen(sofort);
    }

    uiAusZustand() {
      var z = this.z, self = this;
      this.dataset.farbe = z.farbe;
      this.$$('[data-mcf-farbe]').forEach(function (b) { var on = b.dataset.mcfFarbe === z.farbe; b.classList.toggle('ist-an', on); b.setAttribute('aria-pressed', on); });
      this.$$('[data-mcf-weg]').forEach(function (b) { var on = b.dataset.mcfWeg === z.weg; b.classList.toggle('ist-an', on); b.setAttribute('aria-selected', on); });
      this.$$('[data-mcf-panel]').forEach(function (p) { p.hidden = p.dataset.mcfPanel !== z.weg; });
      this.$$('[data-mcf-vorlage]').forEach(function (b) { var on = b.dataset.mcfVorlage === z.vorlage; b.classList.toggle('ist-an', on); b.setAttribute('aria-pressed', on); });
      this.$$('[data-mcf-motiv]').forEach(function (b) { var on = b.dataset.mcfMotiv === z.motiv; b.classList.toggle('ist-an', on); b.setAttribute('aria-pressed', on); });
      var txt = this.$('[data-mcf-feld="text"]'), nm = this.$('[data-mcf-feld="name"]');
      if (txt.value !== z.text) txt.value = z.text;
      txt.maxLength = VORLAGEN[z.vorlage].max;
      if (nm.value !== z.name) nm.value = z.name;
      this.$('[data-mcf-zaehler="text"]').textContent = z.text.length + ' / ' + VORLAGEN[z.vorlage].max;
      this.$('[data-mcf-zaehler="name"]').textContent = z.name.length + ' / 14';
      var tgr = this.$('[data-mcf-feld="textgroesse"]'), tgw = this.$('[data-mcf-tg-wert]');
      if (tgr && +tgr.value !== z.tg) tgr.value = z.tg;
      if (tgw) tgw.textContent = z.tg + ' %';
      var md = this.daten.motive[z.motiv];
      this.$('[data-mcf-motivname]').textContent = md ? md.name : '';
      this.$('[data-mcf-feld="rechte"]').checked = z.rechte;
      var gew = this.$('[data-mcf-gewaehlt]');
      if (gew) gew.textContent = z.weg === 'text' ? 'Wunschtext · ' + VORLAGEN[z.vorlage].name : z.weg === 'bild' ? 'Eigenes Bild' : 'Motiv ' + (md ? md.name : '') + ' + Name';
      this.$$('[data-mcf-farbname]').forEach(function (e) { e.textContent = z.farbe === 'weiss' ? 'Weiß' : 'Schwarz'; });
      // Bild-Bereich
      var hatBild = !!this.bild && !!this.bild.quelle;
      this.$('[data-mcf-bild-regler]').hidden = !hatBild;
      this.$('[data-mcf-bild-info]').hidden = !hatBild;
      this.$('[data-mcf-zone]').classList.toggle('hat-bild', hatBild);
      if (hatBild && this.bild.vorschauUrl) this.$('[data-mcf-bild-mini]').src = this.bild.vorschauUrl;
      this.uploadStatus();
    }

    // ---------- Zeichnen (3D + flach), entprellt ----------
    neuZeichnen(sofort) {
      var self = this;
      clearTimeout(this._zt);
      var los = function () { self.zeichnenJetzt(); };
      if (sofort) los(); else this._zt = setTimeout(los, 140);
    }
    quellen(vorschau) {
      var z = this.z, self = this, d = this.daten.motive[z.motiv];
      var q = { logo: this.q.logo, logoPos: this.daten.logo, motiv: null, bild: this.bild.frei || this.bild.quelle };
      if (z.weg !== 'motiv' || !d) return Promise.resolve(q);
      var url = vorschau ? d.vorschau[z.farbe] : d.druck[z.farbe], key = url;
      if (!this.vorschauBilder[key]) this.vorschauBilder[key] = bildLaden(url);
      return this.vorschauBilder[key].then(function (i) { q.motiv = i; return q; }).catch(function () { delete self.vorschauBilder[key]; return q; });
    }
    zeichnenJetzt() {
      var self = this, z = this.zustandFuerZeichnen(), lauf = (this._lauf = (this._lauf || 0) + 1);
      this.quellen(true).then(function (q) {
        if (lauf !== self._lauf) return;
        var info = null;
        if (self.flasche) {
          self.flasche.setze(z.farbe, function (ctx) {
            ctx.save();
            ctx.translate((MTT3D.UMFANG - RASTER_B) / 2, MTT3D.KOERPER_MM - (MTT3D.H_MM - OBEN_MM));
            info = zeichneDesign(ctx, z, q);
            ctx.restore();
          });
          self.classList.add('ist-3d-bereit');
          if (!self.flasche.nah) self.nachVorne();
        }
        info = self.flachZeichnen(z, q) || info;
        self.hinweise(info);
      });
    }
    zustandFuerZeichnen() {
      var z = Object.assign({}, this.z);
      z.motivDaten = this.daten.motive[z.motiv];
      return z;
    }
    flachZeichnen(z, q) {
      var cv = this.$('[data-mcf-flach]');
      if (!cv) return null;
      var s = 4, ctx = cv.getContext('2d');
      cv.width = RASTER_B * s; cv.height = RASTER_H * s;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.fillStyle = LACK[z.farbe]; ctx.fillRect(0, 0, cv.width, cv.height);
      // Deckelbereich und Bodenring andeuten (dort wird nicht gedruckt)
      ctx.fillStyle = 'rgba(128,128,128,0.25)';
      ctx.fillRect(0, 0, cv.width, (RASTER_H - MTT3D.KOERPER_MM) * s);   // oberste 9,2 mm liegen auf Kunststoffrand/Deckel (v3b)
      ctx.fillRect(0, (RASTER_H - 4.05) * s, cv.width, 4.05 * s);   // Bodenring v3b 4,05 mm
      ctx.setTransform(s, 0, 0, s, 0, 0);
      return zeichneDesign(ctx, z, q);
    }
    flachUmschalten() {
      var an = !this.classList.contains('zeigt-flach');
      this.classList.toggle('zeigt-flach', an);
      var k = this.$('[data-mcf-flach-knopf]');
      if (k) { k.setAttribute('aria-pressed', an); k.textContent = an ? '3D' : 'Druckbild'; }
    }
    // Sanft zur Vorderseite drehen, damit man die Änderung sofort sieht
    nachVorne() {
      var f = this.flasche, ziel = Math.round(f.dreh / (Math.PI * 2)) * Math.PI * 2, start = f.dreh, t0 = performance.now();
      if (Math.abs(ziel - start) < 0.05) return;
      cancelAnimationFrame(this._dl);
      var self = this;
      (function schritt(t) {
        var p = Math.min(1, (t - t0) / 500), e = 1 - Math.pow(1 - p, 3);
        f.dreh = start + (ziel - start) * e; f.kamera();
        if (p < 1) self._dl = requestAnimationFrame(schritt);
      })(t0);
    }

    hinweise(info) {
      var z = this.z, h = this.$('[data-mcf-hinweis-druck]'), t = '';
      if (info && !info.leer && !info.ok && z.weg === 'text' && z.tg < 100) t = 'Bei dieser Textgröße würden die Buchstaben kleiner als ' + MIN_KAPPE.toString().replace('.', ',') + ' mm und feine Linien könnten wegbrechen. Bitte den Regler größer stellen oder den Text kürzen.';
      else if (info && !info.leer && !info.ok) t = 'Der Text ist für diese Vorlage zu lang: Die Buchstaben würden kleiner als ' + MIN_KAPPE.toString().replace('.', ',') + ' mm und feine Linien könnten wegbrechen. Bitte kürzer fassen.';
      h.textContent = t; h.hidden = !t;
      this._druckOk = !info || info.leer || info.ok;
      var aufl = this.$('[data-mcf-aufloesung]');
      if (z.weg === 'bild' && info && info.dpi && this.bild.quelle) {
        var px = this.bild.quelle.naturalWidth || this.bild.quelle.width, dpi = Math.round(info.dpi);
        var mm = Math.round(info.breiteMm) + ' × ' + Math.round(info.hoeheMm) + ' mm';
        if (px < 830) { aufl.textContent = 'Achtung: Dein Bild ist nur ' + px + ' px breit. Für einen scharfen Druck sollte es mindestens 830 px breit sein. Druckgröße ' + mm + '.'; aufl.dataset.stufe = 'warn'; }
        else if (dpi < 300) { aufl.textContent = 'Bei dieser Größe (' + mm + ') kommt dein Bild auf ' + dpi + ' dpi. Etwas kleiner wird es schärfer.'; aufl.dataset.stufe = 'warn'; }
        else { aufl.textContent = 'Auflösung passt: ' + px + ' px breit, ' + dpi + ' dpi bei ' + mm + '.'; aufl.dataset.stufe = 'ok'; }
      }
    }

    // ---------- Eigenes Bild ----------
    dateiGewaehlt(datei) {
      var self = this;
      this.fehler('');
      if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(datei.type) && !/\.(jpe?g|png|webp|heic)$/i.test(datei.name)) { this.fehler('Bitte ein Bild als JPG, PNG oder WEBP wählen.'); return; }
      if (datei.size > 25 * 1024 * 1024) { this.fehler('Das Bild ist größer als 25 MB. Bitte ein kleineres wählen.'); return; }
      var url = URL.createObjectURL(datei);
      bildLaden(url).then(function (img) {
        if (self.bild.vorschauUrl) URL.revokeObjectURL(self.bild.vorschauUrl);
        self.bild = { datei: datei, quelle: img, frei: null, upload: null, laeuft: null, fehler: '', vorschauUrl: url };
        self.z.weg = 'bild';
        if (self.z.freistellen) self.freistellen(); else self.geaendert(true);
        if (self.z.rechte) self.originalHochladen().catch(function () {});
      }).catch(function () {
        URL.revokeObjectURL(url);
        self.fehler('Dieses Bild kann dein Browser nicht öffnen. Bitte als JPG oder PNG speichern und erneut wählen.');
      });
    }
    bildEntfernen() {
      if (this.bild.vorschauUrl) URL.revokeObjectURL(this.bild.vorschauUrl);
      this.bild = { datei: null, quelle: null, frei: null, upload: null, laeuft: null, fehler: '' };
      this.$('[data-mcf-feld="datei"]').value = '';
      this.geaendert(true);
    }
    // Einfarbigen Hintergrund ausblenden: Farbe der vier Ecken, weicher Übergang (Abstand 34 … 80 im RGB-Raum)
    freistellen() {
      var b = this.bild;
      if (!b.quelle) { this.geaendert(true); return; }
      if (!this.z.freistellen) { b.frei = null; this.geaendert(true); return; }
      var w = b.quelle.naturalWidth, h = b.quelle.naturalHeight, f = Math.min(1, 4200 / Math.max(w, h));
      var cv = document.createElement('canvas'); cv.width = Math.round(w * f); cv.height = Math.round(h * f);
      var c = cv.getContext('2d'); c.drawImage(b.quelle, 0, 0, cv.width, cv.height);
      var d = c.getImageData(0, 0, cv.width, cv.height), p = d.data, W = cv.width, H = cv.height;
      var ecken = [[0, 0], [W - 6, 0], [0, H - 6], [W - 6, H - 6]], r = 0, g = 0, bl = 0, n = 0;
      ecken.forEach(function (e) { for (var y = 0; y < 6; y++) for (var x = 0; x < 6; x++) { var i = ((e[1] + y) * W + e[0] + x) * 4; r += p[i]; g += p[i + 1]; bl += p[i + 2]; n++; } });
      r /= n; g /= n; bl /= n;
      for (var i = 0; i < p.length; i += 4) {
        var dr = p[i] - r, dg = p[i + 1] - g, db = p[i + 2] - bl, ab = Math.sqrt(dr * dr + dg * dg + db * db);
        var k = ab <= 34 ? 0 : ab >= 80 ? 1 : (ab - 34) / 46;
        p[i + 3] = Math.round(p[i + 3] * k);
      }
      c.putImageData(d, 0, 0);
      cv.naturalWidth = w; cv.naturalHeight = h;   // für Auflösung und Seitenverhältnis wie das Original
      b.frei = cv;
      this.geaendert(true);
    }
    // Original in den Bucket (erst nach bestätigten Bildrechten)
    originalHochladen() {
      var self = this, b = this.bild;
      if (!b.datei || b.upload || b.laeuft || !this.z.rechte) return b.laeuft || Promise.resolve(b.upload);
      var datei = b.datei, ext = (datei.type.split('/')[1] || '').replace('jpeg', 'jpg');
      var vorbereiten;
      if (/^(jpg|png|webp)$/.test(ext) && datei.size <= MAX_DATEI) vorbereiten = Promise.resolve({ blob: datei, ext: ext });
      else {
        // HEIC oder zu groß: als JPEG (max. 5000 px Kante) neu speichern
        var w = b.quelle.naturalWidth, h = b.quelle.naturalHeight, f = Math.min(1, 5000 / Math.max(w, h));
        var cv = document.createElement('canvas'); cv.width = Math.round(w * f); cv.height = Math.round(h * f);
        cv.getContext('2d').drawImage(b.quelle, 0, 0, cv.width, cv.height);
        vorbereiten = alsBlob(cv, 'image/jpeg', 0.92).then(function (bl) { return { blob: bl, ext: 'jpg' }; });
      }
      b.laeuft = vorbereiten.then(function (x) { return self.hochladen(x.blob, x.ext); })
        .then(function (u) { if (self.bild === b) { b.upload = u; b.laeuft = null; self.uploadStatus(); } return u; })
        .catch(function (e) { if (self.bild === b) { b.laeuft = null; b.fehler = 'Upload fehlgeschlagen. Bitte erneut versuchen.'; self.uploadStatus(); } throw e; });
      this.uploadStatus();
      return b.laeuft;
    }
    uploadStatus() {
      var s = this.$('[data-mcf-upload-status]'), b = this.bild;
      if (!s || !b) return;
      var t = '', stufe = '';
      if (b.quelle && !this.z.rechte) { t = 'Bitte bestätige noch die Bildrechte. Erst dann laden wir dein Bild hoch.'; stufe = 'warn'; }
      else if (b.laeuft) { t = 'Dein Bild wird hochgeladen …'; }
      else if (b.upload) { t = 'Bild sicher hochgeladen.'; stufe = 'ok'; }
      else if (b.fehler) { t = b.fehler; stufe = 'fehler'; }
      s.textContent = t; s.hidden = !t; s.dataset.stufe = stufe;
    }
    hochladen(blob, ext) {
      var sb = this.daten.supabase;
      if (!sb || !sb.url || !sb.anon) return Promise.reject(new Error('Upload ist nicht eingerichtet'));
      var pfad = 'uploads/' + Date.now() + '_' + hex8() + '.' + ext;
      var typ = ext === 'jpg' ? 'image/jpeg' : 'image/' + ext;
      return fetch(sb.url + '/storage/v1/object/' + sb.bucket + '/' + pfad, {
        method: 'POST',
        headers: { apikey: sb.anon, Authorization: 'Bearer ' + sb.anon, 'Content-Type': typ, 'x-upsert': 'false' },
        body: blob
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('Upload ' + r.status + ': ' + t.slice(0, 160)); });
        return { pfad: pfad, url: sb.url + '/storage/v1/object/' + sb.bucket + '/' + pfad, groesse: blob.size };
      });
    }

    // ---------- Druckdatei ----------
    druckdateiBauen() {
      var self = this, z = this.zustandFuerZeichnen();
      return Promise.all([this.fontsBereit, this.quellen(false)]).then(function (r) {
        var q = r[1];
        if (z.weg === 'motiv' && !q.motiv) throw new Error('Motivdatei konnte nicht geladen werden');
        var cv = document.createElement('canvas'); cv.width = DRUCK_W; cv.height = DRUCK_H;
        var ctx = cv.getContext('2d');
        ctx.setTransform(DRUCK_W / RASTER_B, 0, 0, DRUCK_H / RASTER_H, 0, 0);
        // Für den Druck immer das volle Original (bzw. die freigestellte Fassung) nehmen
        q.bild = self.bild.frei || self.bild.quelle;
        var info = zeichneDesign(ctx, z, q);
        if (info.leer) throw new Error('leer');
        return alsBlob(cv, 'image/png').then(function (b) {
          cv.width = cv.height = 1;   // Speicher sofort freigeben (Handy)
          return mitDpi(b);
        }).then(function (b) { return { blob: b, info: info }; });
      });
    }

    pruefen() {
      var z = this.z;
      if (z.weg === 'text' && !z.text.trim()) return 'Bitte gib deinen Wunschtext ein.';
      if (z.weg === 'motiv' && !z.name.trim()) return 'Bitte gib den Namen für dein Motiv ein. Ohne Namen nimm gern die normale Motiv-Flasche.';
      if (z.weg === 'bild') {
        if (!this.bild.quelle) return 'Bitte lade zuerst dein Bild hoch.';
        if (!z.rechte) return 'Bitte bestätige, dass du die Rechte an deinem Bild hast.';
      }
      if (this._druckOk === false) return z.weg === 'text' && z.tg < 100 ? 'Der Text ist bei dieser Größe zu klein für einen sauberen Druck. Bitte den Regler größer stellen oder den Text kürzen.' : 'Der Text ist zu lang für einen sauberen Druck. Bitte kürzer fassen.';
      if (!this.daten.varianten[z.farbe]) return 'Diese Farbe ist gerade nicht verfügbar.';
      return '';
    }

    kaufen(knopf) {
      var self = this, z = this.z;
      if (this._kauft) return;
      var f = this.pruefen();
      if (f) { this.fehler(f); return; }
      this._kauft = true;
      var alt = this.$('[data-mcf-vorschau-ergebnis]'); if (alt) alt.hidden = true;
      var knoepfe = this.$$('[data-mcf-kauf]');
      var text = function (t) { knoepfe.forEach(function (k) { k.querySelector('[data-mcf-kauf-text]').textContent = t; k.disabled = true; }); };
      var zurueck = function () { knoepfe.forEach(function (k) { k.querySelector('[data-mcf-kauf-text]').textContent = 'In den Warenkorb'; k.disabled = false; }); self._kauft = false; };
      text('Druckdatei wird erstellt …');
      var original = z.weg === 'bild' ? this.originalHochladen() : Promise.resolve(null);
      original.catch(function () {});   // Fehler wird unten in der Kette behandelt
      var druck = null;
      this.druckdateiBauen().then(function (d) {
        druck = d;
        text('Wird hochgeladen …');
        if (d.blob.size > MAX_DATEI) {
          // Sehr großes Foto: Druckdatei passt nicht in den Bucket. Original + Layout reichen, die Druckdatei baut werkzeug/druckdatei-holen.py.
          return null;
        }
        return self.hochladen(d.blob, 'png');
      }).then(function (up) {
        return original.then(function (orig) { return { up: up, orig: orig }; });
      }).then(function (r) {
        if (z.weg === 'bild' && !r.orig) throw new Error('Original fehlt');
        var md = self.daten.motive[z.motiv];
        var gestaltung = z.weg === 'text' ? 'Wunschtext · ' + VORLAGEN[z.vorlage].name : z.weg === 'bild' ? 'Eigenes Bild' : 'Motiv ' + md.name + ' + Name';
        var layout = { v: 1, weg: z.weg, farbe: z.farbe, raster_mm: [RASTER_B, RASTER_H], dpi: DPI };
        if (z.weg === 'text') { layout.vorlage = z.vorlage; layout.text = gross(z.text); layout.text_groesse = z.tg; }
        if (z.weg === 'motiv') { layout.motiv = z.motiv; layout.name = gross(z.name); }
        if (z.weg === 'bild') { layout.groesse = z.groesse; layout.lage = z.lage; layout.freistellen = z.freistellen; layout.breite_mm = Math.round(druck.info.breiteMm * 10) / 10; layout.hoehe_mm = Math.round(druck.info.hoeheMm * 10) / 10; }
        var props = { 'Gestaltung': gestaltung };
        if (z.weg === 'text') { props['Text'] = gross(z.text); props['Textgröße'] = z.tg + ' %'; }
        if (z.weg === 'motiv') props['Name'] = gross(z.name);
        props['_druckdatei'] = r.up ? r.up.url : '';
        props['_druckdatei_status'] = r.up ? 'fertig (PNG 600 dpi, 100 x 205 mm)' : 'zu groß für den Bucket: aus _bild_original + _layout bauen';
        if (r.orig) props['_bild_original'] = r.orig.url;
        if (z.weg === 'bild') props['_bildrechte'] = 'vom Kunden bestätigt ' + new Date().toISOString();
        props['_layout'] = JSON.stringify(layout);
        props['_personalisiert'] = 'ja, Kundeneingabe';
        if (self.daten.vorschau) return self.vorschauErgebnis(druck, r, props).then(function () { return 'vorschau'; });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +self.daten.varianten[z.farbe], quantity: 1, properties: props }] })
        }).then(function (resp) {
          if (!resp.ok) return resp.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || ('Warenkorb ' + resp.status)); });
          return resp.json();
        });
      }).then(function (ergebnis) {
        if (ergebnis === 'vorschau') { text('Druckdatei erstellt ✓'); setTimeout(zurueck, 2500); return; }
        text('Im Warenkorb ✓');
        // Die MTT-Schublade (snippets/mtt-schublade.liquid) erkennt den /cart/add-Aufruf und öffnet sich selbst.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(zurueck, 2500);
      }).catch(function (e) {
        console.error('[Custom-Flasche]', e);
        zurueck();
        self.fehler(e && e.message === 'leer' ? self.pruefen() || 'Bitte gestalte zuerst deine Flasche.' :
          'Das hat nicht geklappt: ' + ((e && e.message) || 'unbekannter Fehler') + '. Bitte versuche es noch einmal.');
      });
    }

    // Entwurfs-Vorschau: kein Warenkorb (Entwürfe sind nicht kaufbar), dafür die fertige Druckdatei zum Ansehen
    vorschauErgebnis(druck, r, props) {
      var e = this.$('[data-mcf-vorschau-ergebnis]');
      if (this._vorschauUrl) URL.revokeObjectURL(this._vorschauUrl);
      var url = this._vorschauUrl = URL.createObjectURL(druck.blob);
      var kb = Math.round(druck.blob.size / 1024);
      e.innerHTML = '';
      e.appendChild(document.createTextNode('Vorschau-Modus: Druckdatei erstellt (PNG ' + DRUCK_W + ' × ' + DRUCK_H + ' px, 600 dpi, ' + kb + ' KB) und ' + (r.up ? 'in den Bucket hochgeladen (' + r.up.pfad + ')' : 'NICHT hochgeladen (zu groß)') + '. Warenkorb erst, wenn das Produkt aktiv ist. '));
      var a = document.createElement('a'); a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'Druckdatei ansehen';
      a.download = 'druckdatei-vorschau.png';
      e.appendChild(a);
      e.hidden = false;
      window.MTTCustomFlasche.letzteEigenschaften = props;
      return Promise.resolve();
    }

    fehler(t) {
      this.$$('[data-mcf-fehler]').forEach(function (e) { e.textContent = t; e.hidden = !t; });
    }

    // ---------- 3D ----------
    start3dSpaet() {
      var self = this, cv = this.$('[data-mcf-canvas]');
      if (!cv || !('IntersectionObserver' in window)) { this.start3d(); return; }
      var io = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect(); self.start3d();
      }, { rootMargin: '900px 0px' });
      io.observe(cv);
    }
    start3d() {
      var self = this, cv = this.$('[data-mcf-canvas]');
      ladeThree().then(function (THREE) {
        try { self.flasche = new MTT3D.Flasche(THREE, cv, { display: self.daten.display }); }
        catch (e) { self.ohne3d('Dein Browser zeigt keine 3D-Ansicht. Hier siehst du dein Druckbild.'); return; }
        self._ro = new ResizeObserver(function () { self.flasche.groesse(); });
        self._ro.observe(cv);
        self.neuZeichnen(true);
      }).catch(function () { self.ohne3d('3D-Ansicht konnte nicht geladen werden. Hier siehst du dein Druckbild.'); });
    }
    ohne3d(t) {
      this.classList.add('zeigt-flach', 'ohne-3d');
      var l = this.$('[data-mcf-laden]'); if (l) l.textContent = t;
    }

    // Kaufleiste unten am Handy, sobald der Hauptknopf aus dem Bild ist
    stickyKauf() {
      var leiste = this.$('[data-mcf-leiste]'), knopf = this.$('[data-mcf-kauf-haupt]');
      if (!leiste || !knopf || !('IntersectionObserver' in window)) return;
      var bereich = this.$('.mcf__seite') || this, da = { knopf: true, bereich: false };
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.target === knopf) da.knopf = e.isIntersecting;
          else da.bereich = e.isIntersecting || e.boundingClientRect.top < 0;
        });
        leiste.classList.toggle('ist-sichtbar', da.bereich && !da.knopf);
      });
      io.observe(knopf);
      io.observe(bereich);
      this._io = io;
    }
    disconnectedCallback() { if (this._ro) this._ro.disconnect(); if (this._io) this._io.disconnect(); this._an = false; }
  }

  customElements.define('mtt-custom-flasche', MttCustomFlasche);
  // Für Tests und das Werkzeug: Zeichner von außen erreichbar (z. B. Headless-Prüfung)
  window.MTTCustomFlasche = { zeichneDesign: zeichneDesign, RASTER_B: RASTER_B, RASTER_H: RASTER_H, DRUCK_W: DRUCK_W, DRUCK_H: DRUCK_H };
})();
